import type { PostHog } from "posthog-js";

const PRODUCTION_HOSTS = new Set([
  "atriam.ai",
  "www.atriam.ai",
  "app.atriam.ai",
  "sitecall.ai",
  "www.sitecall.ai",
  "app.sitecall.ai",
]);
const CAMPAIGN_KEYS = [
  "source",
  "medium",
  "campaign",
  "content",
  "term",
] as const;

export function analyticsEnvironment(
  hostname: string,
): "production" | "development" | "preview" {
  if (["localhost", "127.0.0.1", "::1", "[::1]"].includes(hostname))
    return "development";
  return PRODUCTION_HOSTS.has(hostname) ? "production" : "preview";
}

/** Persist the latest tagged campaign through login/onboarding. PostHog's
 * built-in $initial_utm_* remains the first-touch source of truth.
 */
export function registerAcquisitionContext(
  client: Pick<PostHog, "register">,
): void {
  try {
    const url = new URL(window.location.href);
    const campaign: Record<string, string> = {};
    let tagged = false;
    for (const key of CAMPAIGN_KEYS) {
      const value = url.searchParams.get(`utm_${key}`) ?? "";
      // Campaign labels only. Never copy arbitrary URLs, emails, or click IDs.
      const safe = /^[a-zA-Z0-9_. -]{1,120}$/.test(value) ? value : "";
      campaign[`acquisition_${key}`] = safe || "(not set)";
      tagged ||= safe.length > 0;
    }
    client.register({
      analytics_version: 2,
      analytics_environment: analyticsEnvironment(url.hostname),
      ...(tagged ? campaign : {}),
      ...(url.searchParams.get("analytics_test") === "1"
        ? { is_test: true }
        : {}),
      ...(url.searchParams.get("analytics_test") === "0"
        ? { is_test: false }
        : {}),
    });
  } catch {
    // Analytics is best-effort, including in browsers with restricted storage.
  }
}

export function isInternalEmail(email: string | undefined): boolean {
  const domain = email?.trim().toLowerCase().split("@")[1];
  return domain === "atriam.ai" || domain === "sitecall.ai";
}
